"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Text_1 = __importDefault(require("../Text"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Content = styled_1.default.ul ``;
const Wrapper = styled_1.default.div ``;
function SectionList({ heading, subheading, children, }) {
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(Text_1.default, { variant: "headline6" }, heading),
        react_1.default.createElement(Text_1.default, { variant: "body" }, subheading),
        react_1.default.createElement(Content, null, children)));
}
exports.default = SectionList;
